import React, { useState, useEffect } from 'react';
import {
	Box,
	Paper,
	FormControl,
	InputLabel,
	Select,
	SelectChangeEvent,
	MenuItem,
	TextField,
	Typography,
	IconButton,
	Autocomplete,
	Checkbox,
	ListItemText,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	DialogActions,
} from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Delete as DeleteIcon } from '@mui/icons-material';
import dayjs, { Dayjs } from 'dayjs';
import CreateCategories from '../../forms/CreateCategories';
import { addCategory } from '../../../services/api/Category';
import { PostSubCategories } from '../../../services/api/Subcategories';
import CreateSubCategory from './subcategory';

interface MenuSectionProps {
	menu: {
		type?: string;
		menuType?: string;
		items?: string[];
		perPerson?: number;
		totalPersons?: number;
		numberOfPersons?: number;
		datetime?: string;
		discount?: number;
		menuItems?: {
			Items: string[];
		};
		_id?: string;
	};
	onChange: (updatedMenu: any) => void;
	onRemove?: () => void;
	availableMenuTypes: (string | { menuType: string })[];
	categories: string[];
	subcategories: string[];
	setSelectedCategory: React.Dispatch<React.SetStateAction<string>>;
	selectedCategory: string;
	setMenutypedata: React.Dispatch<React.SetStateAction<string>>;
	isDefaultMenu: boolean;
	setDiscountMenu: React.Dispatch<React.SetStateAction<number>>;
	discountMenu: number;
	selectedQuotation: any;
	menuTypes: any;
	// fetchSubcategories: any;
	loadEventTypes: any;
	fetchSubcategories: any;

	// setLoaddiscount: any;
}

const MenuSection: React.FC<MenuSectionProps> = ({
	menu,
	onChange,
	onRemove,
	availableMenuTypes,
	setMenutypedata,
	categories,
	setSelectedCategory,
	subcategories,
	isDefaultMenu,
	setDiscountMenu,
	discountMenu,
	selectedQuotation,
	menuTypes,
	loadEventTypes,
	fetchSubcategories,
}) => {
	console.log(menu, 'menu>>>>>>>>>>>');
	// console.log(menuTypes, 'menuTypes========>>>>>>>>>>>');
	// console.log(availableMenuTypes, 'availableMenuTypes========>>>>>>>>>>>');

	const [selectedSubcategories, setSelectedSubcategories] = useState<string[]>([]);
	const [selectedDateTime, setSelectedDateTime] = useState<Dayjs | null>(null);
	const [menuTypeError, setMenuTypeError] = useState<string | null>(null);
	const [initialCategory, setInitialCategory] = useState<string>('');
	const [openCategoryDialog, setOpenCategoryDialog] = useState(false);
	const [openSubCategoryDialog, setOpenSubCategoryDialog] = useState(false);
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

	// Add these functions for delete confirmation
	const handleDeleteClick = () => {
		setDeleteDialogOpen(true);
	};

	const handleCloseDeleteDialog = () => {
		setDeleteDialogOpen(false);
	};

	const handleConfirmDelete = () => {
		if (onRemove) {
			onRemove();
		}
		setDeleteDialogOpen(false);
	};
	const handleCategorySave = async (category: any) => {
		const formData = new FormData();
		formData.append('name', category.name);
		formData.append('description', category.description);
		formData.append('slug', category.slug);

		if (Array.isArray(category.tag)) {
			category.tag.forEach((tag: any) => formData.append('tag', tag));
		} else {
			formData.append('tag', category.tag || '');
		}

		if (category.categoryImage instanceof File) {
			formData.append('categoryImage', category.categoryImage);
		}
		const response = await addCategory(formData);
		const data = await response?.json();
		console.log(data.data, 'DATAMMMM');

		loadEventTypes();
		setOpenCategoryDialog(false);
	};

	useEffect(() => {
		// console.log(menu, 'initialItems>>>>>');
		const initialItems = menu.menuItems?.Items || menu.items || [];

		setSelectedSubcategories(initialItems);

		if (menu.datetime) {
			setSelectedDateTime(dayjs(menu.datetime));
		}

		const menuType = menu.menuType || menu.type || '';
		if (menuType) {
			setMenutypedata(menuType);
		}

		if (menu.discount !== undefined) {
			setDiscountMenu(menu.discount);
		}
	}, [menu]);

	const handleMenuTypeChange = (e: SelectChangeEvent<string>) => {
		const value = e.target.value;
		if (!value) return;

		setMenutypedata(value);
		onChange({
			...menu,
			menuType: value,
			type: value, // Ensure both properties are set
		});
		setMenuTypeError(null);
	};
	const handleCategoryChange = (e: any, value: string | null) => {
		if (value) {
			setSelectedCategory(value);
			setInitialCategory(value);
			onChange({ ...menu, category: value });
		}
	};

	const handleSubcategoryChange = (e: any, value: string[]) => {
		setSelectedSubcategories(value);
		onChange({
			...menu,
			items: value,
			menuItems: { Items: value }, // Ensure both formats are supported
		});
	};

	const handlePerPersonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const perPerson = parseFloat(e.target.value) || 0;
		onChange({
			...menu,
			perPerson,
			numberOfPersons: menu.numberOfPersons || menu.totalPersons || 0, // Support both formats
			totalPersons: menu.totalPersons || menu.numberOfPersons || 0, // Support both formats
		});
	};

	const handleTotalPersonsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const totalPersons = parseInt(e.target.value) || 0;
		onChange({
			...menu,
			totalPersons,
			numberOfPersons: totalPersons, // Support both formats
		});
	};

	const handleDateTimeChange = (newValue: Dayjs | null) => {
		setSelectedDateTime(newValue);
		onChange({
			...menu,
			datetime: newValue ? newValue.toISOString() : undefined,
		});
	};

	const total =
		(menu.perPerson || 0) * (menu.totalPersons || menu.numberOfPersons || 0) - discountMenu;
	const showDiscountField = menu.menuType || menu.type;

	const handleCreatesubcategory = async (formDataToSend: any) => {
		try {
			const response = await PostSubCategories(formDataToSend);
			const data = await response.json();
			console.log(data, 'response>>>>>>>>>>>>>>>>');
			if (data.success) {
				const labeldata = data?.data?.subcategory?.category;
				fetchSubcategories(labeldata);
			}
			setOpenSubCategoryDialog(false);
			// loadEventTypes()
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	};

	console.log(menuTypes, 'menuType>>>>>>>>>>');

	return (
		<Paper elevation={0} sx={{ p: 3, mb: 3, border: '1px solid #e0e0e0', borderRadius: 1 }}>
			<Box mb={3}>
				<FormControl fullWidth size="small" error={!!menuTypeError} required>
					<InputLabel>Menu Type </InputLabel>
					<Select
						value={menu.menuType || menu.type || ''}
						onChange={handleMenuTypeChange}
						label="Menu Type"
						required
						error={!!menuTypeError}
						disabled={!selectedQuotation}
					>
						{availableMenuTypes.map((type, index) => (
							<MenuItem
								key={index}
								value={typeof type === 'string' ? type : type.menuType}
							>
								{typeof type === 'string'
									? type
									: (type as { menuType: string }).menuType}
							</MenuItem>
						))}
					</Select>
					{menuTypeError && (
						<Typography variant="caption" color="error">
							{menuTypeError}
						</Typography>
					)}
				</FormControl>

				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<DemoContainer components={['DateTimePicker']}>
						<DateTimePicker
							label="Menu Date & Time"
							value={selectedDateTime}
							onChange={handleDateTimeChange}
							views={['year', 'day', 'hours', 'minutes']}
							format="DD/MM/YYYY hh:mm A"
							ampm={true}
							slotProps={{
								textField: {
									fullWidth: true,
									size: 'small',
									margin: 'normal',
									required: true as any, // workaround: MUI's DateTimePicker doesn't pass 'required' to input
									error: !selectedDateTime,
									helperText: !selectedDateTime
										? 'Menu Date & Time is required'
										: '',
								},
							}}
						/>
					</DemoContainer>
				</LocalizationProvider>
			</Box>

			<Box mb={3}>
				<Autocomplete
					options={categories}
					getOptionLabel={(option) => option}
					value={initialCategory}
					onChange={handleCategoryChange}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Category"
							variant="outlined"
							size="small"
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										<Button
											variant="text"
											onClick={() => setOpenCategoryDialog(true)}
											style={{ marginLeft: '20px', color: '#CA0005' }}
										>
											<AddOutlinedIcon />
										</Button>
										{params.InputProps.endAdornment}
									</>
								),
							}}
						/>
					)}
				/>
			</Box>

			<Box mb={3}>
				<Autocomplete
					multiple
					options={subcategories}
					getOptionLabel={(option) => option}
					value={selectedSubcategories}
					disableCloseOnSelect
					onChange={handleSubcategoryChange}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Subcategories"
							variant="outlined"
							size="small"
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										<Button
											variant="text"
											onClick={() => setOpenSubCategoryDialog(true)}
											// style={{ marginRight: '20px', color: '#CA0005' }}
											style={{ marginLeft: '20px', color: '#CA0005' }}
										>
											<AddOutlinedIcon />
										</Button>
										{params.InputProps.endAdornment}
									</>
								),
							}}
						/>
					)}
					renderOption={(props, option, { selected }) => (
						<li {...props}>
							<Checkbox checked={selected} />
							<ListItemText primary={option} />
						</li>
					)}
				/>
			</Box>

			<Dialog
				open={openCategoryDialog}
				onClose={() => setOpenCategoryDialog(false)}
				maxWidth="md"
				fullWidth
			>
				<CreateCategories
					open={openCategoryDialog}
					handleClose={() => setOpenCategoryDialog(false)}
					handleSave={handleCategorySave}
					category={null}
					menuTypes={// availableMenuTypes
					// 	? availableMenuTypes
					// :
					menuTypes?.map((item: any) => item?.menuType || item)}
					loading={false}
				/>
			</Dialog>

			<Dialog
				open={openSubCategoryDialog}
				onClose={() => setOpenSubCategoryDialog(false)}
				maxWidth="md"
				fullWidth
			>
				<DialogContent dividers>
					<CreateSubCategory
						onsubmit={handleCreatesubcategory}
						onClose={() => setOpenSubCategoryDialog(false)}
					/>
				</DialogContent>
			</Dialog>

			<Box
				display="grid"
				gridTemplateColumns={showDiscountField ? 'repeat(6, 1fr)' : 'repeat(5, 1fr)'}
				gap={2}
				mt={3}
				p={2}
				bgcolor="#f5f5f5"
				borderRadius={1}
			>
				<Box textAlign="start">
					<InputLabel>Menu</InputLabel>
					<Typography fontWeight="medium" mt={1}>
						{menu.menuType || menu.type || ''}
					</Typography>
				</Box>

				<Box sx={{ marginTop: 'auto', marginBottom: 'auto' }}>
					{/* <TextField
						label="Rate"
						size="small"
						type="number"
						InputProps={{
							inputProps: {
								// Hide spinner buttons in most browsers
								style: {
									MozAppearance: 'textfield',
									WebkitAppearance: 'none',
									margin: 0,
								},
								// For Chrome, Safari, Edge, Opera
								'::-webkit-outer-spin-button, ::-webkit-inner-spin-button': {
									WebkitAppearance: 'none',
									margin: 0,
								},
							},
						}}
						value={menu.perPerson || ''}
						onChange={handlePerPersonChange}
						fullWidth
						disabled={isDefaultMenu}
					/> */}
					<TextField
						label="Rate"
						size="small"
						type="number"
						InputProps={{
							inputProps: {
								style: {
									// For Firefox
									MozAppearance: 'textfield',
									// For Chrome, Safari, Edge, Opera
									WebkitAppearance: 'none',
									margin: 0,
								},
							},
						}}
						sx={{
							// Target the inner input for Webkit browsers
							'& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
								{
									WebkitAppearance: 'none',
									margin: 0,
								},
						}}
						value={menu.perPerson || ''}
						onChange={handlePerPersonChange}
						fullWidth
						disabled={isDefaultMenu}
					/>
					{/* <TextField
  label="Rate"
  size="small"
  type="number"
  InputProps={{
    inputProps: {
      style: {
        // For Firefox
        MozAppearance: 'textfield',
        // For Chrome, Safari, Edge, Opera
        WebkitAppearance: 'none',
        margin: 0,
      },
    },
  }}
  sx={{
    // Target the inner input for Webkit browsers
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  }}
  value={menu.perPerson ? Number(menu.perPerson).toFixed(2) : ''}
  onChange={handlePerPersonChange}
  fullWidth
  disabled={isDefaultMenu}
/> */}
				</Box>

				<Box sx={{ marginTop: 'auto', marginBottom: 'auto' }}>
					<TextField
						label="Total Persons"
						type="number"
						size="small"
						value={menu.totalPersons || menu.numberOfPersons || ''}
						onChange={handleTotalPersonsChange}
						fullWidth
					/>
				</Box>

				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
						gridColumn: showDiscountField ? 'span 2' : 'span 1',
					}}
				>
					<Box>
						{!isDefaultMenu && (
							<Typography variant="body1" fontWeight="bold">
								Total: ₹{total.toFixed(2)}
							</Typography>
						)}
					</Box>
					{onRemove && (
						// <IconButton onClick={onRemove} >
						<IconButton onClick={handleDeleteClick}>
							<DeleteIcon />
						</IconButton>
					)}
				</Box>
			</Box>
			<Dialog
				open={deleteDialogOpen}
				onClose={handleCloseDeleteDialog}
				maxWidth="xs"
				fullWidth
			>
				<DialogTitle>Confirm Delete</DialogTitle>
				<DialogContent>
					<Typography variant="body1">
						Are you sure you want to delete this menu section? This action cannot be
						undone.
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDeleteDialog} color="primary">
						Cancel
					</Button>
					<Button onClick={handleConfirmDelete} color="error" variant="contained">
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</Paper>
	);
};

export default MenuSection;
